import { useContext } from 'react'
import { toast } from 'react-toastify'

import {
  createSignature as apiCreateSignature,
  updateSignature as apiUpdateSignature,
  SignatureCreate
} from '../../../../../services/signature'
import { useNavigate } from 'react-router-dom'
import {
  SignatureFormatted,
  formatSignature
} from '../../../utils/formatSignature'
import { SignatureFormContext } from '../context'
import { pages } from '../../../../../config/pages'

export function useSignature() {
  const {
    signature,
    loading,
    setLoading,
    updateSignatureState,
    localChangeRecurrence
  } = useContext(SignatureFormContext)
  const navigate = useNavigate()
  function createSignature(
    data: Partial<SignatureCreate>,
    onSuccess?: (data: SignatureFormatted) => void
  ) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => {
        console.log('Payload de criação da assinatura:', data)
        return apiCreateSignature(data)
      })
      .then(data => {
        const formatted = formatSignature(data)
        updateSignatureState(data)
        onSuccess?.(formatted)
      })
      .then(() => toast.info('Assinatura cadastrada com sucesso'))
      .then(() => navigate(pages.signatures.path))
      .finally(() => setLoading(false))
  }

  function updateSignature(
    data: Partial<SignatureFormatted>,
    onSuccess?: (data: SignatureFormatted) => void
  ) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => {
        if (!signature) throw new Error('Assinatura não encontrada')

        return apiUpdateSignature(signature.id, data)
      })
      .then(data => {
        const formatted = formatSignature(data)
        updateSignatureState(data)
        onSuccess?.(formatted)
      })
      .then(() => toast.info('A assinatura foi alterada'))
      .then(() => navigate(pages.signatures.path))
      .finally(() => setLoading(false))
  }

  return {
    signature,
    loading,
    createSignature,
    updateSignature,
    localChangeRecurrence
  }
}
